import { colors, weights } from '@components/theme/styles/index';
import { styled } from '@mui/material';
import { rem } from 'polished';

export const StyledTeam = styled('div')(
  ({ theme }) =>
    ({
      display: 'flex',
      alignItems: 'center',
      gap: rem(20),

      [theme.breakpoints.down('md')]: {
        maxWidth: rem(300),
      },
    }) as any,
);

export const StyledLabel = styled('p')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: rem(5),
  fontWeight: weights.medium,
  color: colors.grayDark2,
  width: 'auto',
  [theme.breakpoints.up(1536)]: {
    width: rem(87),
  },
}));
